export default __webpack_public_path__ + "static/media/cancellation-offer-modal.e158a2c0.jpg";